import { InjectionToken } from '@angular/core';

/**
 * Configurable polling interval (ms) for `SystemsStore`. Following the
 * pattern already used in the repo for configuration tokens (e.g.
 * `ssr-payment-system-ids.token.ts`), the interval must never be embedded
 * as a numeric literal in `SystemsStore`.
 */
export const SYSTEMS_POLLING_INTERVAL_MS: InjectionToken<number> = new InjectionToken<number>(
    'SYSTEMS_POLLING_INTERVAL_MS',
);
